export default __webpack_public_path__ + "static/logo-club-morado-2d7f6a816254509abb6c6faca0d8e28f.png";